import React, {
  Fragment,
  useState,
  useRef,
  useEffect,
  useCallback,
} from "react";
import ReactDOM from "react-dom";
import PropTypes from "prop-types";
import styles from "./styles.module.css";
import useOnOutsideClick from "../../../utils/hooks/onOutsideClick";
import useOnEscapeKeyDown from "../../../utils/hooks/onEscapeKeyDown";
import {
  ScrollOverlay,
  ClickableOverlay,
  StyledModal,
  CloseIcon,
} from "./Styles";
import crossimage from "../../../assets/images/X.svg";
import { useNavigate } from "react-router-dom";

const propTypes = {
  className: PropTypes.string,
  testid: PropTypes.string,
  variant: PropTypes.oneOf(["center", "aside", "topCenter"]),
  width: PropTypes.number,
  height: PropTypes.number,
  maxHeight: PropTypes.number,
  withCloseIcon: PropTypes.bool,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  renderLink: PropTypes.func,
  renderContent: PropTypes.func.isRequired,
  title: PropTypes.string,
  close: PropTypes.func,
  headerHeight: PropTypes.number,
};

const defaultProps = {
  className: undefined,
  testid: "modal",
  variant: "center",
  width: 40,
  height: 60,
  minHeight: 60,
  withCloseIcon: true,
  isOpen: undefined,
  onClose: () => null,
  renderLink: () => null,
  title: undefined,
  close: () => null,
  headerHeight: 5,
};

const ModalForm = ({
  className,
  testid,
  variant,
  width,
  height,
  maxHeight,
  withCloseIcon,
  isOpen: propsIsOpen,
  onClose: tellParentToClose,
  renderLink,
  renderContent,
  title,
  close,
  headerHeight,
  background,
  imgsrc,
  padding,
  dimensionsUnit,
  noNavbar,
}) => {
  const [stateIsOpen, setStateOpen] = useState(false);
  const isControlled = typeof propsIsOpen === "boolean";
  const isOpen = isControlled ? propsIsOpen : stateIsOpen;
  const $modalRef = useRef();
  const $clickableOverlayRef = useRef();
  const navigate = useNavigate();

  const closeModal = useCallback(() => {
    if (!isControlled) {
      setStateOpen(false);
      navigate(`/`);
    } else {
      tellParentToClose();
    }
  }, [isControlled, tellParentToClose]);

  useOnOutsideClick($modalRef, isOpen, closeModal, $clickableOverlayRef);
  useOnEscapeKeyDown(isOpen, closeModal);

  useEffect(() => {
    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = "visible";
    };
  }, [isOpen]);

  return (
    <Fragment>
      {!isControlled && renderLink({ open: () => setStateOpen(true) })}
      {isOpen &&
        ReactDOM.createPortal(
          <ScrollOverlay>
            <ClickableOverlay variant={variant} ref={$clickableOverlayRef}>
              <StyledModal
                className={className}
                style={
                  
                  dimensionsUnit === "px"
                    ? { width: `${width}px`, maxHeight: `${maxHeight}px`,  }
                    : { width: `${width}vw`, maxHeight: `${maxHeight}vh`,   }
                    
                }
                variant={variant}
                width={width}
                padding={padding}
            
                height={height}
                data-testid={testid}
                ref={$modalRef}>
                {!noNavbar && (
                  <div
                    className={styles.header}
                    style={
                      dimensionsUnit === "px"
                        ? { height: `${headerHeight}px` }
                        : {
                            height: `${headerHeight}vh`,
                            backgroundColor: background,
                          }
                    }>
                    <div className={styles.headerTitle}>
                      <img src={imgsrc} />
                      {title}
                    </div>
                    <div
                      id="cancelbtn"
                      style={{ marginTop: "0.6vh", cursor: "pointer" }}>
                      <button className={styles.crossbusston} onClick={close}>
                        <img src={crossimage} alt="crossimage" ></img>
                      </button>
                    </div>
                  </div>
                )}
                {withCloseIcon && (
                  <CloseIcon
                    type="close"
                    variant={variant}
                    onClick={closeModal}
                    src={crossimage}
                  />
                )}
                {renderContent({ close: closeModal })}
              </StyledModal>
            </ClickableOverlay>
          </ScrollOverlay>,
          $root
        )}
    </Fragment>
  );
};

const $root = document.getElementById("root");

ModalForm.propTypes = propTypes;
ModalForm.defaultProps = defaultProps;

export default ModalForm;
